import React from 'react';

import { FeaturedPartner } from '../../utils/backend-api/partners';
import { Button } from '../BaseUI';
import styles from './styles.module.scss';

interface FeaturedPartnerCardProps {
  partner: FeaturedPartner;
}

const FeaturedPartnerCard = ({ partner }: FeaturedPartnerCardProps) => {
  const { id, name, logo, description, buttonText, targetLink } = partner;

  return (
    <div className={styles.partner}>
      <img src={logo} className={styles.logo} />
      <div className={styles.details}>
        <div>
          <h3 className={styles.name}>{name}</h3>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          href={targetLink}
          className={styles.button}
          variant="outline"
          rounded="slight"
          borderWidth="medium"
          trackClick
          trackingProps={{
            name: 'partner_card',
            identifier: id.toString(),
          }}
        >
          {buttonText || 'LEARN MORE'}
        </Button>
      </div>
    </div>
  );
};

export default FeaturedPartnerCard;
